export default "__VITE_ASSET__c07a7de9__"